function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSidebarChat(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#0A1633",
    d: "M8 0a8 8 0 017.106 11.679.498.498 0 01-.675.213.506.506 0 01-.212-.68A6.996 6.996 0 008 1.009C4.134 1.008 1 4.138 1 8c0 3.57 2.68 6.516 6.14 6.94V14h1.72v1.14a.86.86 0 01-.837.859H8l-.063-.001-.296.001a.502.502 0 01-.112-.012A8 8 0 017.999 0zm0 3.75c1.952 0 3.535 1.555 3.535 3.473 0 1.569-1.06 2.895-2.514 3.326l-.137.036v2.187H7.122l-.006-1.208V9.827c0-.445.341-.812.78-.862L8 8.959c.976 0 1.767-.777 1.767-1.736 0-.96-.79-1.737-1.767-1.737-.976 0-1.767.778-1.767 1.737v.43H4.465v-.43C4.465 5.305 6.048 3.75 8 3.75z"
  }));
}

SvgSidebarChat.clsName = 'icon-www__sidebar_chat';
SvgSidebarChat.remarkName = 'unknown';
export default SvgSidebarChat;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/SidebarChat.js
// module id = 2430
// module chunks = 17 18